import { Radio } from '@firesoon/antd';
import React from 'react';
import { radio } from './interface';
import { radioTypes } from './RadioTypes';

interface IRadioGroup {
  defaultType?: number | string;
  onChange?: (e: any) => void;
  isFull?: boolean;
  type?: any;
  extraRadios?: radio;
}

export default ({ type, extraRadios, defaultType = 1, isFull, onChange }: IRadioGroup) => {
  return (
    <Radio.Group
      defaultValue={defaultType}
      size={isFull ? 'large' : 'small'}
      onChange={(e) => onChange?.(e.target.value)}
    >
      {(extraRadios ?? radioTypes[type]).map((item) => (
        <Radio.Button key={item.value} value={item.value}>
          {item.name}
        </Radio.Button>
      ))}
    </Radio.Group>
  );
};
